import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { createSupervisionMeeting, CreateSupervisionMeetingBody, getSupervisionMeeting, getSupervisionMeetings, getSupervisionMeetingsStats } from '@uplift/api';

import { providerQueryKeys } from '../provider/providerQueryKeys';


export const useSupervisionMeetingsStatsQuery = (providerId: string) => {
  return useSuspenseQuery({
    queryKey: providerQueryKeys.supervisionMeetingsStats(providerId),
    queryFn: async () => {
      const response = await getSupervisionMeetingsStats(providerId);

      return response.data;
    },
  });
};


export const useSupervisionMeetingsQuery = (providerId: string) => {
  return useSuspenseQuery({
    queryKey: providerQueryKeys.supervisionMeetings(providerId),
    queryFn: async () => {
      const response = await getSupervisionMeetings(providerId);

      return response.data;
    },
  });
};


export const useSupervisionMeetingQuery = (providerId: string, meetingId: string) => {
  return useSuspenseQuery({
    queryKey: providerQueryKeys.supervisionMeeting(providerId, meetingId),
    queryFn: async () => {
      const response = await getSupervisionMeeting(meetingId);

      return response.data;
    },
  });
};


export const useCreateSupervisionMeetingMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (args: { providerId: string; matchId: string } & CreateSupervisionMeetingBody) => {
      const { providerId, matchId, ...body } = args;

      return createSupervisionMeeting(providerId, matchId, body);
    },
    async onSuccess(_data, variables) {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: providerQueryKeys.collaborativeProviderActivity(variables.providerId) }),
        queryClient.invalidateQueries({ queryKey: providerQueryKeys.supervisionMeetingsStats(variables.providerId) }),
        queryClient.invalidateQueries({ queryKey: providerQueryKeys.supervisionMeetings(variables.providerId) }),
      ]);
    },
  });
};
